import ModuleWrapper from '../modules/ModuleWrapper.js'
import LayoutBase from './LayoutBase'

export default function Layout1({ modules, onUpdate, ...props }) {
  return (
    <LayoutBase cols={1} rows={1} {...props}>
      <div className="col-span-1 row-span-1">
        <ModuleWrapper index={0} module={modules[0]} onUpdate={onUpdate} {...props} />
      </div>
    </LayoutBase>
  )
}
